exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml, body {\n  height: 100%;\n  font-family: 'Josefin Sans', sans-serif;\n  color: #fefff6; }\n\n.full-height {\n  height: 100%; }\n\n.row {\n  margin-bottom: 0px; }\n\n.loading {\n  height: 1000px;\n  color: black; }\n\nmain {\n  background: #fefff6;\n  position: relative;\n  width: 100%;\n  top: -10px;\n  padding-top: 8px;\n  padding-bottom: 20px; }\n  main div {\n    color: black;\n    width: 850px;\n    margin: 0 auto; }\n  main h2 {\n    text-align: center; }\n    main h2 a {\n      color: black; }\n      main h2 a:hover {\n        color: goldenrod; }\n\n@media (max-width: 911px) {\n  main div {\n    width: 100%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/vimeo/vimeo.component.scss
// module id = ../../../../../src/app/vimeo/vimeo.component.scss
// module chunks = main